import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type { ContentTypeProps } from '@nxt-costco-com/forge-digital-components';

const _findByContentType = async function findByContentType<T>(
    contentType: ContentTypeProps,
    enableLivePreview?: boolean,
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        return (await stackClient.stack
            .ContentType(contentType)
            .Query()
            .toJSON()
            .findOne()) as T;
    } catch (err) {
        throw new Error(`An error occurred in _findByContentType: ${err}`);
    }
};

const cached_findByContentType = unstable_cache(
    _findByContentType,
    ['search_findByContentType'],
    {
        revalidate: 1800,
    },
);

export const findByContentType = async function findByContentType<T>(
    contentType: ContentTypeProps,
    enableLivePreview?: boolean,
): Promise<T> {
    const fn =
        typeof window === 'undefined'
            ? cached_findByContentType
            : _findByContentType;

    return fn(contentType, enableLivePreview);
};
